import { InboxOutlined } from "@ant-design/icons";
import "./standardEmptyState.css";

export const StandardEmptyState = ({
  title = "No data available",
  description = "There is no content to display right now.",
}) => {
  return (
    <div className="std-empty-state" role="status" aria-live="polite">
      <InboxOutlined className="std-empty-state__icon" />
      <h3 className="std-empty-state__title">{title}</h3>
      <p className="std-empty-state__description">{description}</p>
    </div>
  );
};
